<template>
  <!-- 底部组件 -->
  <div class="footerComponent">
      <div class="footerWarp">
          <div class="footer_logoInfo">
              <div class="logoInfo_left"><img v-lazy="require('@/assets/logo@2x.png')"></div>
              <div class="logoInfo_right">
                  <div class="logoInfo_right_nameinfo">龙源数字传媒旗下产品</div>
                  <div class="logoInfo_right_content">
                    <p>版权所有©2019 龙源果实保留所有权利</p>
                    <p>京ICP 备10216796 号京公网安备11010202007755</p>
                  </div>
              </div>
          </div>
          <ul v-for="(item,index) in footerList" :key="index">
              <li>{{item.name}}</li>
              <li v-for="(itemSub,indexSub) in item.childList" :key="indexSub+1" @click="goRouter(itemSub.path)">
                  {{itemSub.name}}
              </li>
          </ul>
          <ul>
              <li>龙源果实</li>
              <li class="qrCode"><img v-lazy="require('@/assets/footerNav/erWeiMa.png')"></li>
          </ul>
      </div>
      <bottomTxt />
  </div>
</template>

<script>
import bottomTxt from "@/components/footerComponent/footerBottomTxt"
export default {
  name: 'footerComponent',
  data () {
    return {
        footerList:[
            {
                name:"关于龙源",
                childList:[
                    { name:"关于我们", path:"/other/aboutUs" },
                    { name:"联系我们", path:"/other/contact" },
                    { name:"授权协议", path:"/other/licenseAgreement" },
                    { name:"隐私政策", path:"/other/privacyProtection" },
                ]
            },
            {
                name:"常见问题",
                childList:[
                    { name:"授权/版权", path:"/normalQuestion/accreditQues" },
                    // { name:"购买/支付", path:"/normalQuestion/payQues" },
                    { name:"账号相关", path:"/normalQuestion/accountQues" },
                    { name:"其他问题", path:"/normalQuestion/moreQues" },
                ]
            },
            {
                name:"联系方式",
                childList:[
                    { name:"电话：13621189637 | 18612693683", path:"" },
                    { name:"邮箱：fwp8289@dingtalk.com", path:"" },
                    { name:"地址：北京市东城区前门大街大江胡同131号", path:"" }
                ]
            }
        ]
    }
  },
  methods:{
      goRouter(path){
          console.log(path)
          this.$router.push({path:path})
      }
  },
  mounted(){

  },
  components:{
    bottomTxt
  }
}
</script>

<style scoped lang="less">
.footerComponent{
    // height:220px;
    font-size:14px;
    background: #333333;
    .footerWarp{
        width: 1200px;
        margin: auto;
        font-weight:600;
        padding: 40px 0 45px 0;
        display: flex;
        justify-content: space-between;
        .footer_logoInfo{
            display: flex;
            justify-content: space-between;
            .logoInfo_left{
                height: 135px;
                img{
                    width: 88px;
                    height: 100%;
                }
            }
            .logoInfo_right{
                height: 135px;
                padding-left: 20px;
                color:#ffffff;
                display: flex;
                flex-direction: column;
                .logoInfo_right_nameinfo{
                    font-size: 24px;
                    padding-bottom: 24px;
                }
                .logoInfo_right_content{
                    font-size: 14px;
                }
            }
        }
        ul{
            color:#999999;
            .qrCode{
                img{
                    width: 100px;
                    height: 100px;
                }
            }
            li{
                padding:0px 0;
                margin-bottom:6px;
                cursor: pointer;
            }
            li:active{
                color: #e3e3e3;
            }
            li:hover{
                color: #fff;
            }
            li:nth-child(1){
                color:#ffffff;
                padding: 0;
                cursor:default;
                margin-bottom:20px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/footerComponent/footerComponent.vue